<template>
    <div v-if="editing || adding" class="d-flex flex-column text-body-1">
        <span class="font-weight-bold">Nueva categoría</span>
        <span class="text-body-2 mt-2 mb-4">Introduce el nombre que quieres dar a la categoría.</span>

        <v-text-field v-model="name" label="Nombre de la categoría" outlined dense class="mt-2" />

        <div class="d-flex justify-space-between mt-4">
            <v-btn dark color="green" @click="endAdditionOrEdition()">Guardar</v-btn>
            <v-btn dark color="red" @click="cancelAdditionOrEdition()">Cancelar</v-btn>
        </div>
    </div>
    <div v-else>
        <v-list dense>
            <v-list-item-group :value="value" color="primary">
                <v-list-item link value="" @click="selectCategory('')">
                    <v-list-item-content>Todas las imágenes</v-list-item-content>
                </v-list-item>
                <v-list-item link value="unused" @click="selectCategory('unused')">
                    <v-list-item-content>No usadas</v-list-item-content>
                </v-list-item>
                <v-list-item link value="uncategorized" @click="selectCategory('uncategorized')">
                    <v-list-item-content>Sin categorizar</v-list-item-content>
                </v-list-item>

                <v-subheader>Categorías</v-subheader>

                <v-list-item link v-for="category in categories" :key="category.id" :value="category.id" @click="selectCategory(category.id)">
                    <v-list-item-content>
                        {{ category.name }}
                    </v-list-item-content>
                    <v-list-item-icon class="ma-0 pa-0">
                        <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="beginEdition(category)">
                                    <v-list-item-icon>
                                        <v-icon>mdi-pencil-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>Editar</v-list-item-title>
                                </v-list-item>
                                <v-divider />
                                <v-list-item @click="remove(category.id)">
                                    <v-list-item-icon>
                                        <v-icon color="red darken-4">mdi-delete</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title class="red--text text--darken-4">Eliminar</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-list-item-icon>
                </v-list-item>
            </v-list-item-group>

            <v-list-item @click="beginAddition()">
                <v-list-item-icon>
                    <v-icon class="mr-2">mdi-plus</v-icon>
                </v-list-item-icon>
                <v-list-item-content>Nueva categoría</v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<style scoped lang="scss"></style>

<script lang="ts">
import { GetAllImageCategoriesResponse } from "@/services/ClientInterfaces";
import { DataClient } from "@/services/DataClient";
import { Utilities } from "@/services/Utilities";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class extends Vue {
    @Prop({ required: true, type: String })
    value!: string;

    categories: GetAllImageCategoriesResponse = [];

    id = "";
    name = "";
    adding = false;
    editing = false;

    async mounted() {
        await this.refresh();
    }

    async refresh() {
        this.categories = await DataClient.ImageCategories.getAll();
        Utilities.sortArrayByProperty(this.categories, "name");
    }

    beginAddition() {
        this.name = "";
        this.adding = true;
    }

    beginEdition(item: any) {
        this.id = item.id;
        this.name = item.name;
        this.editing = true;
    }

    async endAdditionOrEdition() {
        if (this.adding) {
            await DataClient.ImageCategories.add({ name: this.name });
            this.adding = false;
            await this.refresh();
        } else if (this.editing) {
            await DataClient.ImageCategories.rename({
                id: this.id,
                name: this.name,
            });
            this.editing = false;
            await this.refresh();
        }
    }

    cancelAdditionOrEdition() {
        this.adding = false;
        this.editing = false;
    }

    async remove(id: string) {
        await DataClient.ImageCategories.delete({ id });
        await this.refresh();
    }

    selectCategory(id: string) {
        this.$emit("input", id);
        this.$emit("change", id);
    }
}
</script>
